import { POSTCODE_REGEXES } from './postcodeRegexes';
export const COUNTRY_USA = 'US';
export const COUNTRY_CANADA = 'CA';
export const COUNTRY_INTL = 'INTL';
export const VALID_LENGTH_CA = 7;
export const VALID_LENGTH_US = 10;
export const VALID_LENGTH_INTL = 10;
export var ErrorMessages;
(function (ErrorMessages) {
    ErrorMessages["Length"] = "ZIP code must be no longer than 10 characters";
    ErrorMessages["LengthCA"] = "Postal code must be no longer than 7 characters";
    ErrorMessages["SymbolsUS"] = "Use only digits without spaces";
    ErrorMessages["SymbolsCA"] = "Use only Latin letters without special symbols";
    ErrorMessages["SymbolsIntl"] = "Use only Latin letters, digits, spaces and '-' symbol";
    ErrorMessages["FormatUS"] = "ZIP code format is incorrect. Example: 12345 or 12345-6789";
    ErrorMessages["FormatCA"] = "Postal code format is incorrect. Example: A1A 1A1";
})(ErrorMessages || (ErrorMessages = {}));
export var TranslationContexts;
(function (TranslationContexts) {
    TranslationContexts["Length"] = "Error text (US and other ZIP codes)";
    TranslationContexts["LengthCA"] = "Error text (Canadian postal codes)";
    TranslationContexts["All"] = "Error text";
})(TranslationContexts || (TranslationContexts = {}));
const isOfValidLength = (postcode, length) => {
    return postcode.length <= length;
};
const validateUSZipCode = (zipcode) => {
    if (!isOfValidLength(zipcode, VALID_LENGTH_US)) {
        return {
            valid: false,
            errorMessage: ErrorMessages.Length,
            _context: TranslationContexts.Length,
        };
    }
    // RegEx to allow only numbers and dashes
    if (!/^[\d-]*$/.test(zipcode)) {
        return {
            valid: false,
            errorMessage: ErrorMessages.SymbolsUS,
            _context: TranslationContexts.All,
        };
    }
    if (!POSTCODE_REGEXES.get(COUNTRY_USA).test(zipcode)) {
        return {
            valid: false,
            errorMessage: ErrorMessages.FormatUS,
            _context: TranslationContexts.All,
        };
    }
    return { valid: true };
};
const validateCanadianPostCode = (postcode) => {
    if (!isOfValidLength(postcode, VALID_LENGTH_CA)) {
        return {
            valid: false,
            errorMessage: ErrorMessages.LengthCA,
            _context: TranslationContexts.LengthCA,
        };
    }
    // RegEx to allow only letters, numbers and spaces
    if (!/^[A-Za-z\d\s]*$/.test(postcode)) {
        return {
            valid: false,
            errorMessage: ErrorMessages.SymbolsCA,
            _context: TranslationContexts.All,
        };
    }
    if (!POSTCODE_REGEXES.get(COUNTRY_CANADA).test(postcode)) {
        return {
            valid: false,
            errorMessage: ErrorMessages.FormatCA,
            _context: TranslationContexts.All,
        };
    }
    return { valid: true };
};
const validateGenericPostCode = (postcode) => {
    if (!isOfValidLength(postcode, VALID_LENGTH_INTL)) {
        return {
            valid: false,
            errorMessage: ErrorMessages.Length,
            _context: TranslationContexts.Length,
        };
    }
    if (!POSTCODE_REGEXES.get(COUNTRY_INTL).test(postcode)) {
        return {
            valid: false,
            errorMessage: ErrorMessages.SymbolsIntl,
            _context: TranslationContexts.All,
        };
    }
    return { valid: true };
};
export const validatePostCode = (postcode, country) => {
    if (!postcode || postcode.trim().length === 0) {
        return { valid: true };
    }
    switch (country.toUpperCase()) {
        case COUNTRY_USA:
            return validateUSZipCode(postcode);
        case COUNTRY_CANADA:
            return validateCanadianPostCode(postcode);
        default:
            return validateGenericPostCode(postcode);
    }
};
